export const generateId = (): string => {
  return 'card-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
};